import { breakpoints, measure } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";
import type { PropsWithChildren } from "react";

import { TitleSecondary } from "./variants/TitleSecondary";

export type SubheaderProps = {
	textAlign?: "center" | "start";
	inverted?: boolean;
} & PropsWithChildren;

const styles = stylex.create({
	root: {
		display: "flex",
		flexDirection: "column",
		paddingBlockStart: measure.spacingVerticalMax,
		paddingBlockEnd: {
			default: measure.spacingVerticalSmaller,
			[breakpoints.md]: measure.spacingVerticalSmaller,
		},
		paddingInline: measure.spacingHorizontalDefault,
	},
	center: {
		justifyContent: "center",
	},
	textAlignCenter: {
		textAlign: "center",
	},
	textAlignStart: {
		textAlign: "start",
	},
});

export const Subheader = ({ children, textAlign = "start", inverted = false }: SubheaderProps) => {
	return (
		<div {...stylex.props(styles.root, textAlign === "center" && styles.center)}>
			<TitleSecondary sx={textAlign === "center" ? styles.textAlignCenter : styles.textAlignStart} inverted={inverted}>
				{children}
			</TitleSecondary>
		</div>
	);
};
